<template>
  <!-- 个人中心 -->
  <div id="Personal">
    <!-- 内容区域 -->

    <head>
      <link rel="stylesheet" href="https://cdn.bootcss.com/material-design-icons/3.0.1/iconfont/material-icons.css">
    </head>

    <el-container style="height: 100%; width: 100%;">
      <!-- <el-header>Header</el-header> -->
      <el-main style="padding: 0px;">
        <el-container>
          <!-- <el-header>Header</el-header> -->
          <el-main style="padding: 0px;">
            <mu-flex direction="column" style="width: 100%;height: 100%;">
              <mu-flex class="is-full-width">

                <img src="../../assets/image/index_bg.bcaa64c.png" style="height: 10rem;width: 100%;" />
                <p
                  style="width: 100%;text-align: center;margin-top: 1.25rem;font-size: 1.5625rem;position: absolute;z-index: 1;color: #fff;margin-top: 3rem;">
                  {{mailStr}}
                </p>
                <p
                  style="width: 100%;text-align: center;margin-top: 1.25rem;font-size: 0.9375rem;position: absolute;z-index: 1;color: #fff;margin-top: 6rem;">
                  {{typeStr}}
                </p>
              </mu-flex>

              <!-- <mu-flex class="is-full-width" fill> -->
              <mu-flex class="is-full-width content" fill style="overflow-y: auto;">

                <el-collapse accordion style="width: 100%;margin-left: 0.625rem;margin-right: 0.625rem;">
                  <!-- <p><i class="header-icon el-icon-info"></i>Transaction record</p> -->
                  <!-- <i class="header-icon el-icon-info"> -->
                  <p @click="record"></i>Transaction record</p>
                  <!-- <div></div> -->
                  <el-collapse-item>
                    <template slot="title"></i>Terms of Service
                    </template>
                    <div>By agreeing to the current terms, you must stop using our services. We recommend that you
                      review the Terms frequently to ensure that you understand the terms and conditions that apply to
                      your access and use of the Services. If you have any questions about the use of this website,
                      please contact the Support Center.
                      These terms and any terms expressly incorporated herein apply to your access to and use of any
                      services provided by LocalBtc. These terms do not in any way alter the terms or conditions of
                      any other agreement you have with LocalBtc's products, services or otherwise. If you use the
                      Service on behalf of any entity, you represent and warrant that (1) that entity is a legally
                      established and validly existing entity in compliance with local laws and regulations, (2) you
                      have the authority to accept these terms on behalf of that entity. If you violate these terms,
                      that entity agrees to be responsible to us for your actions.
                      You should read these Terms and any related documents very carefully. If you do not understand
                      these Terms and any documents referred to herein, you should discuss it with us and seek
                      necessary clarification.
                      Unless otherwise specified, any formal communication with you will be by email. Documents will
                      be sent to you by mail and you should seek to send documents to us in the same way.
                      Unless otherwise agreed, any communication with you will be in English. In the event of any
                      discrepancy between the English version of these Terms and any related English language
                      communication, and any translated version of these Terms or any (applicable) communication in
                      any other language, the English version shall prevail.
                      1. Scope of application
                      This service is only available to users who are 18 years of age or older. By accessing or using
                      our Services, you represent and ensure that you are at least 18 years of age and have not been
                      deprived of your right to use the Services.
                      2. Our Services
                      We provide an online trading platform for trading VFAs (or also known as virtual financial
                      assets, encrypted tokens, digital tokens, cryptocurrencies), as well as derivative services
                      related to virtual financial assets or their indices. Buyers and sellers trade on our platform;
                      LocalBtc as the platform provider is neither buyer nor seller in these trades. Users may request
                      withdrawals of their virtual financial assets, subject to the limitations of these Terms. Users
                      can access their virtual financial assets in wallets established and securely held by LocalBtc.
                      By agreeing to these terms, you expressly agree that your virtual financial assets are stored
                      with the virtual financial assets of other users. The rights and interests of individual users
                      are not identifiable by separate property certificates or other electronic records, and in the
                      event of unavoidable losses, you may not receive all your profits and may share the losses
                      proportionally. You represent and warrant that you will remain the final and valid legal
                      beneficial owner of any virtual financial assets held by LocalBtc, that you will not act as a
                      nominee or trustee for any other person, and that you will not act as a nominee or trustee for
                      any other person without LocalBtc's prior written Transfer, transfer, mortgage, charge, or in
                      any other way create any security interest or encumbrance on the relevant virtual financial
                      assets with the consent.
                      Accuracy of the Site: Every effort has been made to ensure the accuracy of the information on
                      the Site, and the information and content on the Site are subject to change without notice and
                      are provided solely to assist users in making independent decisions. We have taken reasonable
                      steps to ensure the accuracy of the information on the website; however, we do not warrant the
                      accuracy, suitability, reliability, completeness, performance and/or adequacy of the content of
                      any services or products offered on this website, and do not warrant any Direct or indirect
                      losses or damages, delays or failures in the delivery of information and your inability to
                      access the website are not liable. We are not responsible for the use or interpretation of such
                      information.
                      Users must prepare the following equipment and bear the following expenses: (1) Internet access
                      equipment, including but not limited to computers or other Internet access terminals, modems and
                      other Internet access devices; (2) Internet access expenses, including but not limited to
                      network access fees, Internet access equipment Rental fees, mobile phone traffic fees, etc.
                      While accepting various services of the website, you agree to accept various information
                      services provided by us. You hereby authorize us to send you commercial information by email,
                      mobile phone, mailing address, etc. You can choose not to accept various information services by
                      making relevant settings on the website.
                      You understand and agree that the services we provide are provided in accordance with the status
                      quo that can be achieved by existing </div>
                    <!-- <div>在界面中一致：所有的元素和结构需保持一致，比如：设计样式、图标和文本、元素的位置等。</div> -->
                  </el-collapse-item>
                  <el-collapse-item title="RisK Disclosure & Disclaimer">
                    <div>This risk disclosure and disclaimer should be read in conjunction with LocalBtc's Terms of
                      Service. Simply put, we want you to understand the important risk and compliance issues
                      associated with trading on our platform.
                      1. Purpose
                      In order to maintain a sound and compliant digital asset trading platform, we have established
                      and implemented a series of anti-money laundering, anti-terrorist financing and trade and
                      economic sanctions programs ("AML/CFT/Sanctions Program" or "Program"). We are committed to
                      promoting legal and transparent business activities and maintaining a solid reputation among
                      users, regulators and the digital asset industry.
                      2. Business Model
                      We are a global digital asset trading platform, or trading market, where traders come to trade
                      as buyers and sellers, often referred to as market traders and market takers. For clarity,
                      buyers and sellers trade with each other, and LocalBtc is not involved in the actual
                      transaction. Users can log in to the LocalBtc website, and its related application program
                      interface or mobile application (website) to obtain the services provided by LocalBtc.
                      Disclosure: Trading is risky. The risk of loss in trading or holding digital assets can be
                      substantial. Therefore, you should carefully consider whether you are suitable for trading based
                      on your financial situation.
                      3. Regulatory environment
                      We understand that regulators have adopted a variety of approaches to regulate and regulate
                      digital assets, including defining or classifying digital assets as convertible virtual
                      currencies (U.S. FinCEN) or virtual commodities (Hong Kong). As a trading platform, we believe
                      that all digital assets available on the LocalBtc platform belong to an innovative alternative
                      asset class, therefore, digital assets should not be referred to as money or currency.
                      Disclosure: Digital assets are not money or legal tender. Digital assets like Bitcoin and
                      Litecoin are not backed by any government or central bank. At different times we may have some
                      insight into the regulatory approach taken by various government agencies; however, we will
                      always fully comply with the rules and regulations of the countries in which we operate. At the
                      same time, we regularly discuss with regulators and peers the best way to regulate digital asset
                      businesses. Also, LocalBtc does not accept certain clients. To maintain a good reputation in the
                      market and ensure a strong compliance market.
                      We cooperate with government authorities and comply with applicable regulations. As good
                      corporate citizens, law enforcement may request information from us, and we will assist law
                      enforcement investigations to track down and deter illegal activity if the law allows for law
                      enforcement investigations. This also means that our platform is only for law-abiding clients.
                      We hope to provide you with services, and at the same time, we also hope that you can act
                      legally and legally on our platform.
                      4. Our Anti-Money Laundering/Counter-Terrorist Financing Solutions
                      Through a risk-based multi-level control system, we have designed our anti-money laundering and
                      anti-terrorist financing program to reasonably prevent money laundering and terrorist financing.
                      The first tier of the scheme includes rigorous user identification procedures, including
                      verifying the identities of individual and business users. In addition to obtaining
                      identification documents, we also obtain information on beneficial owners/natural persons of
                      their institutions from non-natural users, which is in line with international standards such as
                      the Financial Action Task Force (FATF) requirements.
                      The second tier includes risk-based system controls to ensure that additional customer due
                      diligence is performed. To achieve this, we place users (including beneficial owners) on the
                      list of agencies/persons published in the Finland SAR Government Gazette, the "Office of Foreign
                      Assets Control (OFAC) Sanctions List" and the "United Nations Security Council Sanctions List"
                      and other sanctions lists. filter. We may also screen other lists at our discretion to protect
                      our reputation and customers.
                      The third layer includes continuous monitoring for suspicious activity. If we suspect or have
                      reason to suspect suspicious transaction activity, we will file a suspicious transaction
                      activity report with local regulators, as appropriate. Often, suspicious transactions do not
                      correspond to the customer's known legitimate business or personal day-to-day transaction
                      activities.
                      The above are the main components of our compliance program. However, the most important link to
                      these multi-layered risk control systems is our leadership team and employees, including
                      AML/Risk personnel who perform training, oversight and develop a good compliance culture.
                      5. Risk
                      Digital asset trading is considered high risk. Digital assets are not backed by any government
                      or central bank. Trading or holding digital assets can be very risky. You should carefully
                      consider whether interacting, holding or trad</div>
                  </el-collapse-item>
                </el-collapse>

              </mu-flex>

            </mu-flex>
          </el-main>
          <el-footer style="padding: 0 0px;background-color: #fff;"><mu-button @click="submit" class="signOut">sign out</mu-button></el-footer>
        </el-container>

      </el-main>
      <el-footer style="padding: 0 0px;background-color: #fff;">
          <BottomNav style="height: 100%; width: 100%;"></BottomNav>
          </el-footer>
    </el-container>
  </div>
</template>

<script>
  import BottomNav from '../Bottom-nav.vue'
  import {
    lStorage,
    sStorage
  } from "@Comm/js/Storage.js"
  export default {
    data() {
      return {
        mailStr: '',
        typeStr: 'Lv.'
        // //表格
        // tableData: [{Thao:"ces",mmsi:"123"},{Thao:"ces",mmsi:"123"},{Thao:"ces",mmsi:"123"}],
        // pageIndex: 1,
        // //下拉刷新，上拉加载
        // refreshing: false,
        // loadings: false,
        // loadedall: false
      }
    },
    mounted() {
      var UserInfo = JSON.parse(sStorage.getItem("UserInfo"));
      this.mailStr = UserInfo.mail;
      if (UserInfo.type == 1) this.typeStr = 'Lv.vip';
      else if (UserInfo.type == 2) this.typeStr = 'Lv.svip';
    },
    methods: {
      submit() {
          const that = this;
        this.$confirm('Are you sure you want to quit?', 'Hint', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          // this.$message({
          //   type: 'success',
          //   message: '退出成功!'
          // });
          that.$http.post('/user/LoginOut')
            .then(function(response) {
              console.log(response.data);
              if (response.data.success || response.data.code == 1 || response.data.code == -1) {
                sStorage.clear();
                // that.$message(response.data.message);
                that.$router.replace("/");
                that.$message({
                  type: 'success',
                  message: response.data.message
                });
              } else {
                that.$message.error(response.data.message);
              }
            })
            .catch(function(error) {
              console.log(error);
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'The exit has been cancelled'
          });
        });
        // this.$confirm('您确定要退出吗？', '提示', {
        //           type: 'warning'
        //         }).then(({
        //           result
        //         }) => {
        //           if (result) {
        //             const that = this;
        //             this.$http.post('/user/LoginOut')
        //               .then(function(response) {
        //                 console.log(response.data);
        //                 if (response.data.success || response.data.code == 1) {
        //                   sStorage.clear();
        //                   // that.$message(response.data.message);
        //                   that.$router.replace("/");
        //                 } else {
        //                   that.$message.error(response.data.message);
        //                 }
        //               })
        //               .catch(function(error) {
        //                 console.log(error);
        //               });
        //           }
        //           //  else {
        //           //   that.$toast.message('点击了取消');
        //           // }
        //         });
      },
      record() {
        this.$router.push({
          path: '/M/Order',
          query: {
            instId:''
          }
        })
      }
    },
    components: {
      BottomNav
    }
  };
</script>

<!--  scoped -->
<style>

  @import '../../../Comm/css/CommCSS.css';
  #Personal .mu-appbar .mu-appbar-title {
    text-align: center;
  }

  #Personal .is-full-width {
    width: 100%;
  }

  #Personal .content {
    flex: 1
  }

  #Personal .container {
    width: 100%;
    height: 70%;
    padding-right: 0px;
    padding-left: 0px;
    /* margin-right: auto; */
    /* margin-left: auto; */
  }

  #Personal .signOut {
    width: 80%;
    height: 2.5rem;
    margin: 0 auto;
    /*水平居中*/
    margin-top: 1rem;
    margin-bottom: 1rem;
    display: flex;
    /* padding: 30px; */
    font-size: 15px;
    color: #FFFFFF;
    background-color: #303644;
    border-radius: 30px;
  }
</style>

<style>
  /* .el-message-box__wrapper >>> .el-message-box { */
  
  .el-message-box__wrapper .el-message-box {
    width: 80%;
  }
</style>



// WEBPACK FOOTER //
// src/OK_Scott/components/Personal/Personal.vue